// GRI-04/05 — formata o valor de um indicador GRI pra exibição (tabela
// comparativa, tooltip do gráfico): separador pt-BR + unidade do catálogo
// junto do número. "Número absoluto" não vira sufixo (ninguém escreve
// "498 Número absoluto" — é só uma contagem).
const SEM_SUFIXO = new Set(["Número absoluto", "Razão"]);

export function formatGriValue(value, unit) {
  if (value == null || value === "") return "–";

  const numero = Number(value);
  const texto = Number.isFinite(numero)
    ? numero.toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    : String(value);

  if (!unit || SEM_SUFIXO.has(unit)) return texto;
  return `${texto} ${unit}`;
}
